import localStorage from "localStorage";
import { not, isNil } from "ramda";

export const RECIPIENT_SESSION_KEY = "sessionIsRecipient";

export default {
  hasItem(key) {
    return not(isNil(localStorage.getItem(key)));
  },

  getItem(key) {
    return JSON.parse(localStorage.getItem(key));
  },

  setItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },

  removeItem(key) {
    localStorage.removeItem(key);
  },
};

export const LOCAL_STORAGE_AUTH_KEY = "authInfo";
